/**
 * The retro kit's one window (integration plan slice 6b, the designer's "simple,
 * like a retro SFC game, with a darkly blurred part at the back"): every text
 * over the canvas sits in a `Panel`. A dark translucent fill with the canvas
 * blurred behind it (`--ab-panel-fill`, `--ab-panel-blur`; where the browser
 * cannot blur, a darker fill alone), a 1 px light edge and a 2 px dark line
 * inside it, square corners, no icon, no gradient, no shadow. Variants by
 * placement only: `bottom` (the full-width strip above the pad's row: dialogue),
 * `center` (menus), `corner` (the location's name, the dungeon's band),
 * `prompt` (the small bottom-right word) and `tab` (a window's title in a small
 * panel over its top-left corner, Bravely Default's way: Q52, ADR 0034). Styles
 * in `ui.css`; every colour and size is a CSS variable there.
 */
import type { ComponentProps } from 'react';
import './ui.css';

export type PanelPlacement = 'bottom' | 'center' | 'corner' | 'prompt' | 'tab';

/** A section's props (its `ref` too: a dialogue focuses its window) and the placement. */
export type PanelProps = ComponentProps<'section'> & { readonly placement: PanelPlacement };

export const Panel = ({ placement, className, children, ...rest }: PanelProps) => (
  <section {...rest} className={`ab-panel ab-panel-${placement}${className === undefined ? '' : ` ${className}`}`}>
    {children}
  </section>
);
